import type { ITrialWithTargetLabel } from './types';

export const getInvalidTrialsMessage = (invalidTrials: ITrialWithTargetLabel[]) => {
  if (!invalidTrials?.length) return '';

  const targetLabels = invalidTrials
    .map((trial) => trial?.target?.label?.trim())
    .filter((label): label is string => Boolean(label));

  if (!targetLabels.length) return '';
  return `Data for the following target has not been updated: ${targetLabels.join(', ')}`;
};

export const getMissingFirstPageInfoMessage = (
  clientSignError: boolean,
  interventionError: boolean,
) => {
  if (!clientSignError && !interventionError) return '';

  const missingFields = [
    clientSignError ? 'Signs/Symptoms observed' : null,
    interventionError ? 'Evidence-based interventions used' : null,
  ].filter(Boolean);

  return `Missing information ${missingFields.join(', ')} on page 1`;
};
